<div *ngIf="visible" class="dialog">
	<div class="container-dynamic-grid">
		<div class="closing-modal-btn" *ngIf="closable" (click)="close()" aria-label="Close">
			<i class="fa fa-2x fas fa-times"></i>
		</div>
		<h3 style="text-align: center">Are you sure you want to delete <br>{{itemName}}?</h3><br>
		<div style="display:flex; justify-content: space-evenly;">
			<div class="form-group col-md-4">
				<button (click)="choice('No')"
						class="form-control btn btn btn-primary primary-default-btn">Cancel
				</button>
			</div>

			<div class="form-group col-md-4">
				<button (click)="choice('Yes')"
						class="form-control btn btn btn-primary primary-default-btn">Delete
				</button>
			</div>
		</div>
		<ng-content></ng-content>
	</div>
	<div *ngIf="visible" class="overlay" (click)="close()"></div>
</div>
